/**
 * Busca cidades via Open-Meteo Geocoding (sem chave).
 * @param {string} query
 * @param {string} [countryCode] ISO2 maiúsculo — restringe resultados
 * @returns {Promise<{ name: string, country: string, countryCode: string, admin1?: string }[]>}
 */
export async function searchCitiesOpenMeteo(query, countryCode) {
  const q = String(query || "").trim();
  if (q.length < 2) return [];

  let url = `https://geocoding-api.open-meteo.com/v1/search?name=${encodeURIComponent(q)}&count=12&language=pt`;
  const cc = String(countryCode || "").trim().toUpperCase();
  if (cc.length === 2) {
    url += `&country=${encodeURIComponent(cc)}`;
  }

  const res = await fetch(url);
  if (!res.ok) return [];
  const data = await res.json();
  const results = data.results;
  if (!Array.isArray(results)) return [];

  return results.map((r) => ({
    name: r.name || "",
    country: r.country || "",
    countryCode: (r.country_code || "").toUpperCase(),
    admin1: r.admin1 || "",
  }));
}
